import React from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Link } from "react-router-dom";
// import { loginRequest } from "../auth/authConfig";
import { SignInButton } from "./SignInButton";

export const Navigation: React.FC = () => {
	const { accounts } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	// const handleLogout = () => {
	// 	// Use popup logout which doesn't cause page redirects
	// 	instance.logoutRedirect({
	// 		postLogoutRedirectUri: "/",
	// 	});
	// };

	return (
		<nav className="bg-blue-600 text-white shadow-lg">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-16">
					{/* Logo */}
					<div className="flex-shrink-0 flex items-center">
						<a href="./">
							<img
								src="/images/bblogo.png"
								alt="PuffRelay Logo"
								className="h-16"
							/>
						</a>
					</div>
					{/* Navigation Links */}
					<div className="flex items-center space-x-4">
						{isAuthenticated ? (
							<>
								<Link
									to="/"
									className="px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition"
								>
									Home
								</Link>
								<Link
									to="/create-po"
									className="px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition"
								>
									Create PO
								</Link>
								<a
									href="/po-list?reset=true"
									className="px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition"
								>
									PO List
								</a>

								{/* User Info and Logout */}
								<div className="flex items-center space-x-3 border-l border-blue-400 pl-4">
									<span className="text-sm">{accounts[0]?.name}</span>
									{/* <button
									onClick={handleLogout}
									className="px-3 py-1 bg-red-500 hover:bg-red-600 rounded-md text-sm transition"
								>
									Logout
								</button> */}
								</div>
							</>
						) : (
							<div className="flex items-center space-x-3 border-l border-blue-400 pl-4">
								{/* <button
									onClick={handleLogin}
									className="px-3 py-1 bg-red-500 hover:bg-red-600 rounded-md text-sm transition"
								>
									Login
								</button> */}
								<SignInButton />
							</div>
						)}
					</div>
				</div>
			</div>
		</nav>
	);
};
